module.exports = "/_next/static/chunks/images/homepage-desktop-background-c1a25e620c0b20c718b60f38495f1193.svg";